import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAllMinistersForCache } from "@/Services/ministers.service";
import type { Minister } from "@/models/minister";

export const ALL_MINISTERS_QUERY_KEY = ["allMinisters"] as const;

/**
 * Global minister cache — all ministers (active + inactive), no binary photo.
 * staleTime: 1 hour. Write operations must call invalidateAllMinisters() after.
 * refetchOnWindowFocus/Mount disabled — one fetch per session under normal use.
 */
export function useAllMinisters() {
  return useQuery<Minister[]>({
    queryKey: ALL_MINISTERS_QUERY_KEY,
    queryFn: getAllMinistersForCache,
    staleTime: 60 * 60 * 1000,  // 1 hour
    gcTime: 60 * 60 * 1000,     // 1 hour
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}

/**
 * Returns a stable callback that invalidates the global minister cache.
 * Call after any create/update/delete/lifecycle mutation.
 */
export function useInvalidateAllMinisters() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ALL_MINISTERS_QUERY_KEY });
}
